module.exports = __webpack_public_path__ + "static/media/being_three.cdce9635.png";